var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-footer"},[_c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-container1"},[_c('span',{staticClass:"footer-text"},[_vm._v("CrimeLogic")]),_c('span',[_vm._v("Copyright © 2022")])])]),_c('img',{staticClass:"footer-image",attrs:{"alt":"image","src":"/playground_assets/waves-white.svg"}})])
}]

export { render, staticRenderFns }